import type { OptimizationUpdateMessage } from '@/shared/api/socket-messages'
import type { Message } from '@/shared/api/websocket/types'

import { useEffect, useEffectEvent } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { OptimizationStatus } from '@/shared/generated'
import { useOptimizationGroupId } from '@/shared/hooks/useOptimzationGroupId'
import { $optimizationUpdate } from '@/shared/lib/socket'

export const useListenSocket = () => {
	const queryClient = useQueryClient()
	const optimizationGroupId = useOptimizationGroupId()!
	const handler = useEffectEvent((msg: Message<OptimizationUpdateMessage>) => {
		if (
			![OptimizationStatus.Updating, OptimizationStatus.Pending].includes(
				msg.payload.optimization_status as OptimizationStatus
			)
		) {
			queryClient.invalidateQueries({
				queryKey: ['assortment-list'],
			})
		}
	})
	useEffect(() => {
		$optimizationUpdate.on(
			`optimization:${optimizationGroupId}:update`,
			handler
		)

		return () => {
			$optimizationUpdate.off(
				`optimization:${optimizationGroupId}:update`,
				handler
			)
		}
	}, [optimizationGroupId, queryClient])
}
